import { customElement, property, state, query, queryAll } from 'lit/decorators.js'
import { RaygunElement } from '@src/js/common/rg-element.js'

@customElement('rg-subnavigation')
export class Subnavigation extends RaygunElement {

  @queryAll('[click-trigger]')
  triggers = []

  @state({ type: Boolean })
  get isDesktop() {
    return window.innerWidth > 1200
  }

  registerEvents() {
    return {
      'window.resize': this.onResize,
      'document.keydown:esc': this.onEscKeyDown,
      'click': this.handleClickEvents,
      'change': this.onMobileInputChange
    }
  }

  handleClickEvents = (e) => {
    this.triggers.forEach(el => {
      if (el === e.target || el.contains(e.target)) {
        const callback = el.getAttribute('click-trigger')
        if (this[callback]) {
          e.preventDefault()
          this[callback](e);
        }
      }
    })
  }

  onMobileInputChange(e) {
    const { jumpMenu } = this.refs
    if (jumpMenu) {
      const option = jumpMenu.selectedOptions[0];
      if (option) {
        global.location.href = option.value
      }
    }
  }

  toggleElement(el, visible) {
    if (el) {
      el.classList.toggle('is-hidden', !visible)
    }
  }

  openSubnav(event) {
    const menu = event.target.closest('li');
    const transition = menu.querySelector('rg-expand-transition')
    transition.toggleAttribute('active')
    transition.closest('li').classList.toggle('is-expanded')
  }
}